import React from 'react';
import {NavBar, Header} from './modules';
import {Dialog} from './components';
import cs from 'classnames';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

class App extends React.Component {
    state = {
        'navbarToggled': false,
        'smallMenu': false,
        'requestShow': false,
    };

    toggleNavBar(e) {
        e.preventDefault();
        this.setState({
            'navbarToggled': !this.state.navbarToggled
        });
    }

    toggleSmallMenu(e) {
        e.preventDefault();
        this.setState({
            'smallMenu': !this.state.smallMenu
        });
    }

    exit() {
        this.setState({
            'requestShow': true
        });
    }

    render() {
        const {children, location: {pathname}, dialog, user} = this.props;
        return (
            <div className={cs("app layout-fixed-header", {
                "offscreen move-left": this.state.navbarToggled,
                'layout-small-menu': this.state.smallMenu
            })}>
                <NavBar
                    toggled={this.state.navbarToggled}
                    toggleMe={this.toggleNavBar.bind(this)}
                    onExit={this.exit.bind(this)}
                    path={pathname}
                    onToggle={this.toggleSmallMenu.bind(this)}
                    user={user}
                />
                <div className="main-panel">
                    <Header onToggle={this.toggleNavBar.bind(this)} onExit={this.exit.bind(this)}/>
                    <div className="main-content">
                        {children}
                        <Dialog body="Несохраненные данные будут утеряны, вы уверены, что не хотите сохранить их?"
                                title="Внимание! Некоторые данные не сохранены"
                                yesTitle="Да!"
                                noTitle="Нет"
                                show={false}
                                {...dialog}
                        />
                        <Dialog
                            show={this.state.requestShow}
                            body="Ви впевнені, що хочете вийти?"
                            title="Вихід"
                            yesTitle="Так"
                            yes={() => {
                                this.setState({
                                    'requestShow': false
                                });
                                browserHistory.push("/logout");
                            }}
                            noTitle="Ні, дякую"
                            no={() => this.setState({requestShow: false})}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        dialog: state.dialog,
        user: state.auth.credentials
    }
}

export default connect(mapStateToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/